import React, { useState } from 'react';

import { useParams } from 'react-router-dom';

import CRMApi from '../../../../Api/CRM/CRMApi';
import GetUserLootboxResponse from '../../../../Api/CRM/Responses/Lootbox/UserLootboxResponse';
import { formatDateStringWithTimezone } from '../../../../utils/formatters';
import ProtectedLink from '../../../elements/ProtectedLink';
import BooleanIcon from '../../../elements/booleanIcon';
import { PERMISSION } from '../../../helpers/Permissions';
import useOnce from '../../../hooks/useOnce';

import Card from 'crm/elements/common/Card';
import Row, { TableDetailsBody } from 'crm/elements/common/TableDetailsRow';

export default function UserLootboxDetailsPage() {
    const { id } = useParams<{ id: string }>();
    const [lootboxTicket, setLootboxTicket] = useState<GetUserLootboxResponse>({} as GetUserLootboxResponse);
    useOnce(() => CRMApi.userLootboxes.getById(parseInt(id)).then(setLootboxTicket));

    return (
        <Card title="Lootbox Ticket details">
            <TableDetailsBody>
                <Row label="ID">{lootboxTicket.id}</Row>
                <Row label="Token">{lootboxTicket.token}</Row>
                <Row label="User E-mail">
                    <ProtectedLink
                        url={`/users/${lootboxTicket.user_id}`}
                        value={lootboxTicket.email}
                        permissions={[PERMISSION.VIEW_USER]}
                    />
                </Row>
                <Row label="Pool item id">{lootboxTicket.lootbox_pool_item_id}</Row>
                <Row label="Reward id">
                    <ProtectedLink
                        url={`/lootbox_rewards/${lootboxTicket.lootbox_item_id}`}
                        value={lootboxTicket.lootbox_item_id}
                        permissions={[PERMISSION.VIEW_USER]}
                    />
                </Row>
                <Row label="Is Open">
                    <BooleanIcon value={lootboxTicket.is_open} />
                </Row>
                <Row label="Paid Out">
                    <BooleanIcon value={lootboxTicket.paid_out} />
                </Row>
                <Row label="Created at">{formatDateStringWithTimezone(lootboxTicket.created_at)}</Row>
            </TableDetailsBody>
        </Card>
    );
}
